import { UseFormRegister, UseFormRegisterReturn } from 'react-hook-form';
import { FormData } from './types';
import Lang from '@lang/en';

const getRegisteredFieldsForEditOrder = (
  register: UseFormRegister<FormData>
): Record<string, UseFormRegisterReturn> => {
  const validationEditOrderModal = {
    referenceCodeField: register('referenceCode'),
    barcodeNumberField: register('barcodeNumber', {
      maxLength: {
        value: 25,
        message: Lang.healthCheckEditOrderIncorrectBarcodeNumberText,
      },
      pattern: {
        value: /^[0-9]*$/,
        message: Lang.healthCheckEditOrderIncorrectBarcodeNumberText,
      },
    }),
    testTypeField: register('testType'),
    testCategoryField: register('testCategory'),
  };

  return validationEditOrderModal;
};

export default getRegisteredFieldsForEditOrder;
